import { Core } from "@faire/slate/foundation/color";
import { Flex } from "@faire/web/slate/Layout";
import React from "react";
import styled, { css, keyframes } from "styled-components";

export const NotificationBubbleDot: React.FC<{
  hasHighPriority?: boolean;
  shouldAnimate?: boolean;
  delayAnimationTime?: number;
  dataTestId?: string;
}> = ({ hasHighPriority, shouldAnimate, dataTestId, delayAnimationTime }) => {
  return (
    <Dot
      data-test-id={dataTestId}
      $shouldAnimate={shouldAnimate}
      $hasHighPriority={hasHighPriority}
      style={{
        animationDelay: delayAnimationTime
          ? `${delayAnimationTime}ms`
          : undefined,
      }}
    />
  );
};

const bounce = keyframes`
  0%, 100% {
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  40% {
    width: 12px;
    height: 12px;
    opacity: 1;
  }
  45% {
    width: 11px;
    height: 11px;
    opacity: 1;
  }
  50%, 100% {
    width: 12px;
    height: 12px;
    opacity: 1;
  }
`;

const Dot = styled(Flex)<{
  $shouldAnimate?: boolean;
  $hasHighPriority?: boolean;
}>`
  border-radius: 50%;
  background: ${({ $hasHighPriority }) =>
    $hasHighPriority
      ? css`#e65126`
      : css`
          ${Core.surface.primaryInverse}
        `};
  border: 2px solid ${Core.text.primaryInverse};

  ${({ $shouldAnimate }) =>
    $shouldAnimate
      ? css`
          animation: ${bounce} 2s ease-in-out;
        `
      : css`
          width: 12px;
          height: 12px;
          opacity: 1;
        `}
  animation-fill-mode: both;
`;
